import React, {  } from 'react';
import useGlobal from '../../store';
import ClaimableItemCard from '../Gift/ClaimableItemCard';
import GiftIdeas from '../General/GiftIdeas';
import EmptyGiftlist from '../General/EmptyGiftlist';

const Wishlist = (props) => {

    const [giftlist] = useGlobal(
        state => state.activeGiftlist.giftlist
    );

    const [user, uiActions] = useGlobal(
        state => state.activeGiftlist.user,
        actions => actions.uiActions
    );

    const items = giftlist.map(item => <ClaimableItemCard key={item.itemID} {...item}></ClaimableItemCard>);

    const openSidePanel = () => {
        let paramState = {
            selectedUser: user
        }
        uiActions.toggleSidePanel("additem", paramState);
    }

    return (
        <>
            {user && giftlist && items.length > 0 ? <></> : <EmptyGiftlist handler={openSidePanel}></EmptyGiftlist>}
            <div className="card-columns">
                {items}
            </div>
            <GiftIdeas user={user}></GiftIdeas>
        </>
    );
}
export default Wishlist;